import classNames from 'classnames';
import { DragEvent, ReactNode, useCallback } from 'react';

import { IconSvg, Text } from '@/lib/v2/components';

import { TriggerIcon } from '@/src/modules/AutomationModuleNew/icons';
import { JourneyNodeTypes, NodeTypes } from '@/src/modules/AutomationModuleNew/types/flowsTypes';

type DragAndDropIconType = NodeTypes;

type DragAndDropNodeProps = {
  label?: string;
  iconType?: DragAndDropIconType;
  noBorderButton?: boolean;
  subType: JourneyNodeTypes;
  onDragStart?: (event: DragEvent<HTMLDivElement>, subType: JourneyNodeTypes) => void;
  isDisabled?: boolean;
};

const DragAndDropNode = ({
  label,
  iconType,
  noBorderButton = false,
  subType,
  onDragStart,
  isDisabled = false,
}: DragAndDropNodeProps) => {
  const containerClasses = classNames(
    'flex w-full flex-row items-center gap-2 py-2 dndnode cursor-grab',
    {
      'border-b': !noBorderButton,
      'pointer-events-none opacity-50': isDisabled,
    }
  );

  const getIcon = useCallback((iconType?: DragAndDropIconType) => {
    if (!iconType) return undefined;
    const iconTypesMap: Record<DragAndDropIconType, ReactNode | undefined> = {
      trigger: <TriggerIcon />,
      action: undefined,
      conditional: undefined,
    };
    return iconTypesMap[iconType] || undefined;
  }, []);

  const icon = getIcon(iconType);

  return (
    <div
      draggable
      className={containerClasses}
      onDragStart={(event) => onDragStart?.(event, subType)}
    >
      {icon && <IconSvg svgComponent={icon} />}
      <Text variant="text">{label}</Text>
    </div>
  );
};

export default DragAndDropNode;
